import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { task } from "ember-concurrency";
import { arg } from "glesys-controlpanel/utils/arg";
import { instanceOf } from "prop-types";
import Server from "glesys-controlpanel/models/server";
import Project from "glesys-controlpanel/models/project";
import { tKey } from "ember-intl";

export default class extends Component {
  @service router;

  @arg(instanceOf(Server)) server;
  @arg(instanceOf(Project)) project;

  @tracked backups;

  @action
  goToBackupRoute() {
    this.router.transitionTo("server.backup");
  }

  translations = {
    daily: tKey("server.details.backup.schedules.daily"),
    weekly: tKey("server.details.backup.schedules.weekly"),
    monthly: tKey("server.details.backup.schedules.monthly"),
    manual: tKey("server.details.backup.schedules.manual"),
  };

  get manualBackups() {
    return this.backups?.filter((backups) => backups.frequency == null);
  }

  get schedulesAndManualBackupsWithTranslationString() {
    return this.server.backup?.schedules
      ?.map((schedule) => ({
        ...schedule,
        translationString: this.translations[schedule.frequency] || tKey("server.details.backup.schedules.custom"),
        backups: this.backups?.filter((backup) => {
          return backup.frequency == schedule.frequency;
        }),
      }))
      .concat(
        this.manualBackups?.length
          ? [
              {
                numberofimagestokeep: this.manualBackups.length,
                translationString: this.translations["manual"],
                backups: this.manualBackups,
              },
            ]
          : [],
      );
  }

  get hasBackups() {
    return Boolean(this.schedulesAndManualBackupsWithTranslationString?.length);
  }

  loadBackups = task(async () => {
    this.backups = (await this.server.backups).slice().sort((a, b) => b.createdAt - a.createdAt);
  });
}
